import type { ProductLogoMediumProps } from '../types';

/**
 * 中サイズのBusinessOperationEventsロゴアイコン
 */
export function ProductLogoMediumBusinessOperationEvents({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <rect width="40" height="40" rx="5.88235" fill="#1A2142" />
      <path
        fill="#57D7D9"
        d="M7.76562 8.47053C7.76562 8.08068 8.08166 7.76465 8.47151 7.76465H14.8244C15.2143 7.76465 15.5303 8.08068 15.5303 8.47053V12.7058C15.5303 13.0957 15.2143 13.4117 14.8244 13.4117H8.47151C8.08166 13.4117 7.76562 13.0957 7.76562 12.7058V8.47053Z"
      />
      <path
        fill="#57D7D9"
        d="M24.0009 26.8235C24.0009 26.4336 24.317 26.1176 24.7068 26.1176H31.0597C31.4496 26.1176 31.7656 26.4336 31.7656 26.8235V31.0588C31.7656 31.4486 31.4496 31.7647 31.0597 31.7647H24.7068C24.317 31.7647 24.0009 31.4486 24.0009 31.0588V26.8235Z"
      />
      <path
        fill="#57D7D9"
        d="M16.9421 16.9411C16.5522 16.9411 16.2362 17.2572 16.2362 17.647V21.8823C16.2362 22.2721 16.5522 22.5882 16.9421 22.5882H22.5892C22.979 22.5882 23.295 22.2721 23.295 21.8823V17.647C23.295 17.2572 22.979 16.9411 22.5892 16.9411H16.9421Z"
      />
      <path
        fill="white"
        d="M31.0597 9.8823C31.4252 9.8823 31.7258 10.1601 31.762 10.516C31.7644 10.5397 31.7656 10.5638 31.7656 10.5882V19.7646C31.7656 20.1545 31.4496 20.4705 31.0597 20.4705H25.4127C25.0228 20.4705 24.7068 20.1545 24.7068 19.7646C24.7068 19.3748 25.0228 19.0588 25.4127 19.0588H30.3539V11.2941L17.648 11.2941C17.2581 11.2941 16.9421 10.978 16.9421 10.5882C16.9421 10.1983 17.2581 9.88229 17.648 9.88229L31.0597 9.8823Z"
      />
      <path
        fill="white"
        d="M22.5892 28.9411C22.5892 28.5513 22.2731 28.2352 21.8833 28.2352H9.17739V20.4705H14.1186C14.5084 20.4705 14.8244 20.1545 14.8244 19.7646C14.8244 19.3748 14.5084 19.0588 14.1186 19.0588H8.47151C8.08166 19.0588 7.76562 19.3748 7.76562 19.7646V28.9411C7.76562 29.331 8.08166 29.647 8.47151 29.647H21.8833C22.2731 29.647 22.5892 29.331 22.5892 28.9411Z"
      />
    </svg>
  );
}
